import { z } from 'zod'

import { zDiscountRowTypeEnum } from '@/schemas/discountRowTypeEnumSchema'

export const zDiscountApplied = z.object({
  id: z.string(),
  percentage: z.number(),
  fixPrice: z.nullable(z.number()),
  minimumQuantityNeeded: z.nullable(z.int()),
  quantityOrdered: z.int(),
  minimumApplicableQuantity: z.nullable(z.int()),
  discountSourceId: z.nullable(z.string()),
  startDate: z.nullable(z.iso.datetime()),
  endDate: z.nullable(z.iso.datetime()),
  discountType: zDiscountRowTypeEnum,
  //assortmentNode: z.nullable(z.iso.datetime()).default(null),
  isNettable: z.boolean(),
  isApplied: z.boolean(),
})

export type DiscountAppliedSchema = z.infer<typeof zDiscountApplied>
